import { defineMessages } from 'react-intl';

export default defineMessages({
  symbolNotFoundTitle: {
    id: 'cboard.components.SymbolNotFound.symbolNotFoundTitle',
    defaultMessage: 'Oh no!'
  },
  symbolNotFoundText: {
    id: 'cboard.components.SymbolNotFound.symbolNotFoundText',
    defaultMessage: 'Pictogram not found'
  }
});
